"use client";

import React from "react";

const WhyFluorideIsEssential: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        Why Fluoride Treatment is Essential for Teeth Health
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        The National Institute of Dental and Craniofacial Research reports that tooth decay is a common childhood disease, affecting over 50 percent of children aged 5 to 9. Fluoride treatments play a vital role in preventing this by strengthening tooth enamel and helping to reverse early signs of decay.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        You might be wondering why fluoride treatment is so important if we already consume it through our water and food. While that&rsquo;s true, the amount of fluoride obtained from these sources can vary greatly depending on where you live. Fluoride treatments at your dentist&rsquo;s office ensure that you receive a concentrated dose of this essential mineral, providing an extra layer of protection for your teeth.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Fluoride treatments are particularly important for children as their permanent teeth begin to erupt. Strong tooth enamel during the early stages of tooth development can help prevent decay and cavities throughout their lives. But adults can also benefit from fluoride treatments, especially if they&rsquo;re at a higher risk for developing tooth decay due to factors like dry mouth, gum disease, or a history of frequent cavities.
      </p>
    </div>
  );
};

export default WhyFluorideIsEssential;